<template>
  <WsRead
    ref="WsRead"
    localeMode
    :label="label"
    :fields="fields"
    :id="$route.params.id"
    :modelName="modelName"
    :customBtns="customBtns"
    :submodelName="subModelName"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    :itemVersionReadable="false"
    @sort="$_onOpenSortDialog()"
    @input="$_getModelData($event)"
  >
    <WsSortDialogGeneral
      ref="WsSortDialogGeneral"
      paramsKey="order"
      setLayersKey="order"
      modelName="index/all"
      parentModelName="answr_setting"
      getLayersKey="answer_setting_items"
      :parentId="_id"
      :title="_title"
      :isOnlyOutputItemLayers="false"
      :getUrl="`answr_setting/${_id}/update/item/sequence`"
      @updateSort="$_onDoneSort()"
    />
  </WsRead>
</template>

<script>
import model from '@/models/option';
import subModel from '@/models/optionItem';

export default {
  data() {
    return {
      modelName: model.modelName,
      subModelName: subModel.modelName,
      label: model.label,
      fields: model.fields,
      pageSetting: {
        primary: [
          {
            type: 'infoCard',
            hideOnNull: false,
            floors: [
              {
                fields: ['locales'],
              },
            ],
          },
          {
            type: 'expandList',
            label: subModel.label,
            modelName: subModel.modelName,
            fields: subModel.fields,
            orderBy: 'created_at',
            titleKey: 'name',
            fieldsRead: subModel.fieldsRead,
            searchMode: false,
            hideOnNull: true,
            isGetAll: true,
            staticModelData: (rawData) => {
              const setCheckboxValue = (rawData) => {
                return rawData === 1 ? [1] : [];
              };
              const {
                answer_setting_items,
                has_child,
                has_remark,
                locales,
                risk_level,
              } = rawData;
              const answerSettingItems = answer_setting_items.map(item => {
                return {
                  ...item,
                  has_child: setCheckboxValue(item.has_child),
                  has_remark: setCheckboxValue(item.has_remark),
                }
              });
              rawData.optionItem = {
                answer_setting_items: answerSettingItems,
                has_child: setCheckboxValue(has_child),
                has_remark: setCheckboxValue(has_remark),
                locales,
                risk_level,
              };
              return rawData;
            },
            customCreateAction: (rawData) => {
              return this.$_setSubmitAnswerSettingItemData(rawData);
            },
            customUpdateAction: (rawData) => {
              return this.$_setSubmitAnswerSettingItemData(rawData);
            },
            extendParams: () => {
              return {order_by: 'sequence', order_way: 'asc'};
            }
          },
        ],
        secondary: [
          {
            type: 'infoCard',
            floors: [
              {
                title: '建立資訊',
                fields: ['created_admin', 'created_at'],
              },
            ],
          },
          {
            type: 'infoCard',
            floors: [
              {
                title: '編輯資訊',
                fields: ['updated_admin', 'updated_at'],
              },
            ],
          },
        ],
      },
      customBtns: [
        {
          title: `變更順序`,
          color: 'textSecondary',
          outlined: true,
          icon: 'mdi-compare-horizontal',
          emit: 'sort',
        },
      ],
      modelData: {},
    }
  },
  computed: {
    _selectingLocale() {
      return this.$store.state.locale.selectingLocale;
    },
    _id() {
      return this.$route.params.id;
    },
    _title() {
      return this.modelData && this.modelData.locales ? this.modelData.locales[this._selectingLocale].name : '';
    }
  },
  methods: {
    $_setSubmitAnswerSettingItemData(rawData) {
      const setCheckboxValue = (tarVal) => {
        return tarVal === null
          ? false
          : tarVal.length > 0;
      };
      const {
        risk_level,
        has_child,
        has_remark,
        locales,
        answer_setting_items,
      } = rawData.optionItem;
      const hasChild = setCheckboxValue(has_child);
      const hasRemark = hasChild
        ? false
        : setCheckboxValue(has_remark);
      const riskLevel = hasChild
        ? null
        : risk_level;
      const answerSettingItems = answer_setting_items.map((rawData) => {
        const {
          id,
          risk_level,
          has_remark,
          locales,
        } = rawData;
        const result =  {
          has_child: false,
          risk_level,
          has_remark: setCheckboxValue(has_remark),
          locales,
        };
        if (id) result.id = id;
        return result;
      });
      return {
        risk_level: riskLevel,
        has_child: hasChild,
        has_remark: hasRemark,
        answer_setting_items: hasChild ? answerSettingItems : [],
        locales,
      };
    },
    $_onOpenSortDialog() {
      this.$refs.WsSortDialogGeneral.open();
    },
    $_getModelData($event) {
      this.modelData = $event;
    },
    $_setSortList(rawDataList) {
      return rawDataList.map(rawData => this.$_test(rawData));
    },
    $_test(rawData) {
      const {id, locales, name, answer_setting_items} = rawData;
      const _name = locales && locales[this._selectingLocale]
        ? locales[this._selectingLocale].name
        : name;
      let subLayer = [];
      if (answer_setting_items && answer_setting_items.length) subLayer = answer_setting_items.map(item => this.$_test(item));
      return {
        id,
        name: _name,
        subLayer,
      };
    },
    async $_onDoneSort() {
      const list = this.$refs.WsRead.$refs[`WsReadContentBlock_primary_1`][0].$refs.wsDataExpandList;
      list.modelDatas = [];
      list.page = 1;
      list.stopFetch = false;
      await list.fetchData();
    }
  }
};
</script>